import { useState, useEffect } from "react";
import { Listbox } from "@headlessui/react";

function MyListbox({ onValueChange, name, options }) {
    const [selectedItem, setSelectedItem] = useState(options[0]);

    useEffect(() => {
        onValueChange(selectedItem.name);
    }, [selectedItem]);

    return (
        <Listbox value={selectedItem} onChange={setSelectedItem}>
            <Listbox.Label>{name} type: </Listbox.Label>
            <Listbox.Button className='relative ml-2 w-[auto] cursor-pointer rounded-md border bg-white px-3 text-main-800'>
                {selectedItem.name}
            </Listbox.Button>
            <Listbox.Options className='max-w-[10rem  ] absolute mt-1 bg-white px-4'>
                {options.map((item) => (
                    <Listbox.Option
                        className='m-1 w-[10rem] cursor-pointer text-center text-main-800'
                        key={item.id}
                        value={item}
                    >
                        {item.name}
                    </Listbox.Option>
                ))}
            </Listbox.Options>
        </Listbox>
    );
}

export default MyListbox;
